import { DispatcherEvent } from '@carvana/merch-native';
import { useCallback } from 'react';
import OrderState from '~/constants/orderState';
import { useIsLoggedIn } from '~/context/common/UserContext';
import {
  useCloseAccountModal,
  useOpenAccountModal
} from '~/hooks/common/useAccountModal';
import { useGetUserPurchasingGetter } from '~/hooks/vdp/services/useGetUserPurchasing';
import { type PurchaseEventPayload } from '~/native/common/contracts';

type OnContinue = () => void;

export default function useLogInAndStartPurchase(
  eventPayload: PurchaseEventPayload
) {
  const isLoggedIn = useIsLoggedIn();
  const openAccountModal = useOpenAccountModal();
  const closeAccountModal = useCloseAccountModal();
  const getUserPurchasing = useGetUserPurchasingGetter();

  return useCallback(
    (confirmContinue: OnContinue, onContinue: OnContinue) => () => {
      if (isLoggedIn) return onContinue();

      openAccountModal({
        callerIdentifier: 'StartPurchase',
        nativeOptions: {
          eventPayload,
          eventDispatch: DispatcherEvent.StartPurchase,
          eventSource: 'vdp'
        },
        onSuccess: async () => {
          const purchaseResult = await getUserPurchasing();

          closeAccountModal();

          if (purchaseResult?.orderState === OrderState.Reserved) {
            confirmContinue();
          } else {
            onContinue();
          }
        }
      });
    },
    [
      closeAccountModal,
      eventPayload,
      getUserPurchasing,
      isLoggedIn,
      openAccountModal
    ]
  );
}
